import { cn } from '@heroui/react';
import { FC, ReactNode } from 'react';

interface BrandMenuItemProps {
  icon: ReactNode;
  label: ReactNode;
  endContent?: ReactNode;
  onPress?: () => void;
  onHover?: () => void;
  href?: string;
  isActive?: boolean;
  'data-testid'?: string;
}

export const BrandMenuItem: FC<BrandMenuItemProps> = ({
  icon,
  label,
  endContent,
  onPress,
  onHover,
  href,
  isActive = false,
  'data-testid': dataTestId
}) => {
  const classes = cn(
    'flex w-full items-center gap-2 rounded-md p-2 text-left !text-label-lg outline-none transition-colors hover:bg-surface-container-low focus-visible:bg-surface-container-low',
    isActive
      ? 'bg-surface-container-low text-on-surface'
      : 'text-on-surface-variant'
  );

  const content = (
    <>
      {icon}
      <span className='flex-1 whitespace-nowrap'>{label}</span>
      {endContent}
    </>
  );

  if (href) {
    return (
      <a
        href={href}
        target='_blank'
        rel='noreferrer'
        data-testid={dataTestId}
        className={classes}
        onClick={onPress}
        onMouseEnter={onHover}
      >
        {content}
      </a>
    );
  }

  return (
    <button
      type='button'
      data-testid={dataTestId}
      className={classes}
      onClick={onPress}
      onMouseEnter={onHover}
    >
      {content}
    </button>
  );
};
